import(/* webpackMode: "eager" */ "/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog-detail/BlogDetailBreadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog-detail/BlogDetailContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog-detail/BlogDetailContent.tsx");
